export default class UspsBanner {
  constructor() {
    if(document.querySelector('.USPs__linklist') !== null) {
      this.init();
    }
  }

  init() {
    $('.USPs__linklist').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      mobileFirst: true,
      autoplaySpeed: 2000,
      responsive: [{
          breakpoint: 505,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            draggable: false
          }
        }
      ]
    });

  }
}